import { toSafeString } from '@shared/utils';

const getRoleSortKey = (member) => {
  const roleLabel = toSafeString(member?.roleLabel).toLowerCase();

  if (roleLabel === 'owner') {
    return '0-owner';
  }

  return `1-${roleLabel || 'unknown role'}`;
};

const getMemberNameSortKey = (member) => {
  return toSafeString(member?.displayName || member?.email).toLowerCase();
};

const sortMemberItems = (members = []) => {
  return [...(Array.isArray(members) ? members : [])].sort((left, right) => {
    const leftRoleKey = getRoleSortKey(left);
    const rightRoleKey = getRoleSortKey(right);

    if (leftRoleKey !== rightRoleKey) {
      return leftRoleKey.localeCompare(rightRoleKey);
    }

    const leftNameKey = getMemberNameSortKey(left);
    const rightNameKey = getMemberNameSortKey(right);

    if (leftNameKey !== rightNameKey) {
      return leftNameKey.localeCompare(rightNameKey);
    }

    return toSafeString(left?.email).toLowerCase().localeCompare(toSafeString(right?.email).toLowerCase());
  });
};

export default sortMemberItems;
